import { render, staticRenderFns } from "./cargosDataTable.vue?vue&type=template&id=5b794138&"
import script from "./cargosDataTable.vue?vue&type=script&lang=js&"
export * from "./cargosDataTable.vue?vue&type=script&lang=js&"
import style0 from "./cargosDataTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports